module.exports = __webpack_public_path__ + "static/media/gd.56fdbab2.svg";